module.exports = __webpack_public_path__ + "img/chair3.6adc63fa.jpg";